// Single source of the application's identity in the UI. Mirrors
// backend/core/branding.py (APP_NAME, APP_FULL_NAME, APP_DISPLAY_TITLE) -
// change both together. public/index.html and public/manifest.json cannot
// import this file, so they repeat the title (checked by branding.test.js).
export const APP_NAME = 'ICMS';
export const APP_FULL_NAME = 'Intelligent Claims Management System';
export const APP_DISPLAY_TITLE = `${APP_NAME} – ${APP_FULL_NAME}`;
export const ASSISTANT_NAME = `${APP_NAME} AI Assistant`;

// Describes the data loaded, not the application. The claims are synthetic
// demonstration records (relabelled from the original Mazda data onto the
// Hyundai carlines - migrations/m0004_multibrand_claim_data.py). The note
// names no manufacturer, so it stays true whatever the catalogue holds; the
// models themselves are listed from the database.
export const CURRENT_DATA_SCOPE =
  'Claims data is synthetic demonstration data and does not represent real manufacturer warranty history.';
